var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTools(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "53 28 94 144",
    viewBox: "53 28 94 144",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M128.806 172h-66.71c-1.675 0-3.032-1.342-3.032-3v-45h-3.032c-1.675 0-3.032-1.342-3.032-3V97c0-1.658 1.358-3 3.032-3h78.839c1.676 0 3.032 1.342 3.032 3v24c0 1.658-1.356 3-3.032 3h-3.032v45c0 1.658-1.357 3-3.033 3zm-63.677-6h60.645v-45c0-1.658 1.356-3 3.032-3h3.032v-18H59.065v18h3.032c1.675 0 3.032 1.342 3.032 3v45z",
    fill: "#8F8C8C",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.548 97h-6.065V61c0-3.308-2.72-6-6.065-6s-6.065 2.692-6.065 6v36H80.29V61c0-6.618 5.441-12 12.129-12s12.129 5.382 12.129 12v36z",
    fill: "#8F8C8C",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F8C8C",
    d: "M101.517 67v6H83.323v-6h18.194z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F8C8C",
    d: "M101.517 79v6H83.323v-6h18.194z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F8C8C",
    d: "M134.871 64v32.332h-6.065V64h6.065z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 106h-6.065V70c0-1.655-1.359-3-3.032-3h-21.226v29.332h-6.065V64c0-1.658 1.356-3 3.032-3h24.258c5.016 0 9.097 4.037 9.097 9v36z",
    fill: "#8F8C8C",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.839 64h-6.065V52c0-1.655-1.359-3-3.032-3s-3.032 1.345-3.032 3v12h-6.065V52c0-4.963 4.081-9 9.097-9s9.097 4.037 9.097 9v12z",
    fill: "#8F8C8C",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.161 96.332h-6.065V31c0-1.658 1.358-3 3.032-3h24.258c1.675 0 3.032 1.342 3.032 3v21h-6.065V34H68.161v62.332z",
    fill: "#8F8C8C",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F8C8C",
    d: "M74.226 43v6h-9.097v-6h9.097z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F8C8C",
    d: "M74.226 61v6h-9.097v-6h9.097z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F8C8C",
    d: "M74.226 79v6h-9.097v-6h9.097z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F8C8C",
    d: "M86.355 118v6H62.097v-6h24.258z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F8C8C",
    d: "M134.871 118v6h-18.194v-6h18.194z",
    "data-color": 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTools);
export default __webpack_public_path__ + "static/media/icon-tools.27158e60e4499da0a4b7ea61724f8f4f.svg";
export { ForwardRef as ReactComponent };